<template>
  <div id="app">
    <GalleryList :galleryList="gallery_list" :renderPicturesView="renderPicturesView" />
  </div>
</template>

<script>
import GalleryList from "./components/GalleryList.vue";

export default {
  name: "App",
  delimiters: ["[[", "]]"],
  components: {
    GalleryList,
  },
  data() {
    return {
      // eslint-disable-next-line
      gallery_list: Array.from(galleries, (x) => ({
        title: x.fields.title,
        admin_urls: x.admin_urls,
        photos: x.fields.photos,
        description: x.fields.description
      })),
      // eslint-disable-next-line
      renderPicturesView: quotePicturesView
    };
  },
};
</script>

<style></style>
